import { format } from 'date-fns';

export const formatCurrency = function (value: number): string {
  return new Intl.NumberFormat('es-AR', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: true,
  }).format(value);
};


export const formatDate = function (value: number | Date, pattern:string): string {
  const date = typeof value === 'number' ? new Date(value) : value;
  return format(date, pattern);
};

export const upperCase = function (value: string): string {
  if(value) {
    return value.toUpperCase();
  }
  return "";
};